import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';

const Target = () => {
    return (
        <div className="ck10-target">
            <FullWrapper>
                <div className="ck10-targetWrapper">
                    <div className="ck10-targetLeft">Цель</div>
                    <div className="ck10-targetRight">
                        Увеличить количество заявок до&nbsp;400&nbsp;в месяц и&nbsp;снизить
                        стоимость качественно лида минимум в&nbsp;2&nbsp;раза.
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default Target;
